<template>
    <div>
        <div class="container mt-8 mx-auto">
            <div class="grid grid-cols-4 gap-x-12">
                <div class="lg:col-span-2 col-span-4">
                    <HoursPanel :user="user" />

                    <div v-if="user.type == 'pro'">
                        <MyOrganizations :user="user" :organizations="user.organizations" :show_status="settings" :show_search_box="true"/>
                    </div>
                </div>
                <!-- Section for third column in grid template -->
                <div class="lg:col-span-2 col-span-4">
                    <ProfileInfo :user="user" :professions="professions" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EditHoursModal from "./partials/EditHoursModal.vue";
import EditBannerImageModal from "./partials/EditBannerImageModal.vue";
import EditProfileImageModal from "./partials/EditProfileImageModal.vue";
import ProfileInfo from "./partials/ProfileInfo.vue";
import PinnedPings from "./partials/PinnedPings.vue";
import HoursPanel from "./partials/HoursPanel.vue";
import { posts } from "../../testData";
import Hours from "../Storefront/partials/Hours.vue";
import EditButton from "./partials/EditButton.vue";
import MyOrganizations from "../Dashboard/partials/MyOrganizations";
export default {
    data() {
        return {
            posts: posts,
            banner: {
                title: "Default banner",
                path: "/images/example-banner.png",
            },
            editProfileImageModalVisible: false,
            settings: "settings",
        };
    },
    props: ["user", "professions"],
    methods: {
        onBannerSelected(banner) {
            this.banner = banner;
        },
        onShowEditProfileImageModal() {
            this.editProfileImageModalVisible = true;
        },
        onEditProfileImageModalHidden() {
            this.editProfileImageModalVisible = false;
        },
        onSaveProfileImage(image) {
            // TODO: handle submission of profile image edit
        },
    },
    components: {
        ProfileInfo,
        PinnedPings,
        HoursPanel,
        EditHoursModal,
        EditBannerImageModal,
        EditProfileImageModal,
        Hours,
        EditButton,
        MyOrganizations,
    },
};
</script>
